import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/incidents/incident-list/{-$id}')({
  beforeLoad: () =>
    getTitleContextSlice(
      window.location.pathname.toLowerCase().endsWith('/threats/incidents/incident-list') ? 'Incident list' : 'Incident details'
    ),
  staticData: {
    owner: CodeOwner.SWB,
  },
});
